import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { catchError, delay, filter, map, mergeMap, switchMap } from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { getIdleTs } from "../reducers/idle";
import { getActiveRosterView } from "../reducers/roster";
import { getIsSearchingRoster, getRosterSearchTerm } from "../reducers/rosterSearch";
import { executeOperation } from "../utils/effects";
import { Epic } from "../utils/types";

// epics

const onRoomTypeChanged: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.selectRosterView)),
        filter(
            ({ payload: { elementId } }) =>
                elementId === "all" ||
                elementId === "forums" ||
                elementId === "dialogs" ||
                elementId === "external"
        ),
        map(() => {
            const activeRosterView = getActiveRosterView(state$.value);
            return actionCreators.updateTopSearchInput(
                activeRosterView === "dialogs"
                    ? "direct"
                    : activeRosterView === "forums"
                    ? "forum"
                    : activeRosterView === "external"
                    ? "contact"
                    : undefined,
                getRosterSearchTerm(state$.value)
            );
        })
    );

const onUpdateTopSearchInput: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.updateTopSearchInput)),
        filter(({ value }) => !!value),
        mergeMap(({ value, roomType }) => {
            return executeOperation(() =>
                App.proto.getRoster(
                    {
                        search: value,
                        limit: 30,
                        filter: roomType ? { type: roomType } : undefined,
                    },
                    { tag: `[search ${value}]` }
                )
            ).pipe(
                mergeMap(({ result$ }) =>
                    result$.pipe(
                        map(data => {
                            return actionCreators.onRosterSearchResults(data);
                        })
                    )
                ),
                catchError(err => {
                    console.error("getRoster (search) failed", err);
                    return of<never>();
                })
            );
        })
    );

const onInactivityReset: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.onIdle)),
        switchMap(() =>
            of(actionCreators.rosterSearchOff()).pipe(
                delay(60000),
                filter(() => !!getIdleTs(state$.value) && getIsSearchingRoster(state$.value))
            )
        )
    );

export const rosterSearchEpic = combineEpics(
    onRoomTypeChanged,
    onUpdateTopSearchInput,
    onInactivityReset
);
